import { LinearProgress } from "@mui/material";
import { Loader } from "components/loader/loader";
import { Fragment } from "react";

interface LoaderProps  {
    loading: boolean;
}

const LoaderWrapper = (props: React.PropsWithChildren<LoaderProps>) => {
    return <Fragment>
        {props.loading 
            ? <Loader isDisplay type="linear" />
            : props.children}
        </Fragment>
};

export default LoaderWrapper;